<div class="col-sm-12 text-center pt-2">
    <h1 id="title-widget-steps" class="title-widget mt-2">
      {{multilingualContent.header.headerPasos}}
    </h1>
  </div>
